module.exports = __webpack_public_path__ + "img/direction_icon.a2107a9c.png";